import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Srodstvo } from './srodstvo';

@Component({
  selector: 'yt-srodstvo',
  templateUrl: './srodstvo.component.html'
})
export class SrodstvoComponent extends BaseModalContainer<Srodstvo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Srodstvo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
